
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/sectionizer/panels/sectionizerPanel/copyPasteBar.scss.css.virtualfile';
        module.exports = {"buttons":"_buttons_1am0g_1"};